<template>
  <td>{{ ip }}</td>
</template>

<script>
  export default {
    name: "TableIpLabel",
    props: ['ip']
  }
</script>

<style scoped>
  td {
    text-align: center !important;
  }
</style>
